import {IdName} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';

export class Insurance extends IdName {
  current?: boolean;
}

export class InsuranceAddItem {
  collective?: IdName;
  collectiveId?: number;
  policyNumber?: number;
  cardNumber?: number;
}
